import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Breadcrumbs with BreadcrumbList JSON-LD for SEO.
export default function Breadcrumbs({ items }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: `https://duckthebugs.com${it.to || ""}`,
    })),
  };
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <ol className="flex items-center flex-wrap gap-1.5 text-xs font-mono uppercase tracking-wider text-forest-950/50">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {it.to ? (
              <Link to={it.to} className="hover:text-terracotta transition-colors">
                {it.label}
              </Link>
            ) : (
              <span className="text-forest-950/80">{it.label}</span>
            )}
            {i < items.length - 1 && <ChevronRight className="w-3 h-3 opacity-40" />}
          </li>
        ))}
      </ol>
    </nav>
  );
}
